import { render, staticRenderFns } from "./CouponsList.vue?vue&type=template&id=ff8c68d8&scoped=true"
import script from "./CouponsList.vue?vue&type=script&lang=js"
export * from "./CouponsList.vue?vue&type=script&lang=js"
import style0 from "./CouponsList.vue?vue&type=style&index=0&id=ff8c68d8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8c68d8",
  null
  
)

export default component.exports